export default "__VITE_ASSET__28db1b99__"